import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter} from 'react-router-dom';


import { Provider } from 'react-redux';
import { Route} from 'react-router-dom';
import { I18nextProvider } from "react-i18next";
import i18n from "i18n";

import App from 'App';
import './index.css';

//const middlewares = [thunk];
//const rootReducer = combineReducers({apiReducer, app:appReducer});
//const store = createStore(rootReducer, initialState, applyMiddleware(...middlewares));

ReactDOM.render(
	
		<HashRouter> 
			<I18nextProvider i18n={i18n}>
				<Route path="/" component={App}  />
			</I18nextProvider>
		</HashRouter> 	
	
	,
  document.getElementById('root')
);
